export default class CloseCustomerUnlinkModal {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.modal.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/close_customer_unlink_modal.js